import { ProductPreview } from '../components/ProductPreview';
import { Filters } from '../components/Filters';
import { Carousel } from '../components/Carousel';
import { StoryLinks } from '../components/StoryLinks';
import { FontEditorManager } from '../components/FontEditorManager';
import { AjaxLoader } from '../components/AjaxLoader';
import { Buy } from '../components/Buy';
import { Cart } from '../components/Cart';
import { Checkout } from '../components/Checkout';
import { FileInput } from '../components/FileInput';
import { Notices } from '../components/Notices';
import { ScrollSpy } from '../components/ScrollSpy';
import { Accordion } from '../components/Accordion';
import { Menu } from '../components/Menu/Menu';
import { Page } from '../components/Page';
import { Share } from '../components/Share';
import { Story } from '../components/Story';
import { Trial } from '../components/Trial';
(new Filters()).init();
(new Carousel()).init();
(new StoryLinks()).init();
(new FontEditorManager()).init();
(new AjaxLoader()).init();
(new ProductPreview()).init();
(new Buy()).init();
(new Cart()).init();
(new Checkout()).init();
(new FileInput()).init();
(new Notices()).init();
(new ScrollSpy('.scrollspy-menu', '.scrollspy-element', 108)).init();
(new Accordion()).init();
(new Menu()).init();
(new Page()).init();
(new Share()).init();
(new Story).init();
(new Trial).init();
